goog.provide("shadow.js.shim.module$rehype_raw$default");
shadow.js.shim.module$rehype_raw$default = shadow.js.shim.module$rehype_raw.default;
